/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootboxRedemption } from './LootboxRedemption';
import {
    LootboxRedemptionFromJSON,
    LootboxRedemptionFromJSONTyped,
    LootboxRedemptionToJSON,
    LootboxRedemptionToJSONTyped,
} from './LootboxRedemption';

/**
 * 
 * @export
 * @interface GetLootboxRedemptionsResponse
 */
export interface GetLootboxRedemptionsResponse {
    /**
     * 
     * @type {Array<LootboxRedemption>}
     * @memberof GetLootboxRedemptionsResponse
     */
    lootboxRedemptions: Array<LootboxRedemption>;
}

/**
 * Check if a given object implements the GetLootboxRedemptionsResponse interface.
 */
export function instanceOfGetLootboxRedemptionsResponse(value: object): value is GetLootboxRedemptionsResponse {
    if (!('lootboxRedemptions' in value) || value['lootboxRedemptions'] === undefined) return false;
    return true;
}

export function GetLootboxRedemptionsResponseFromJSON(json: any): GetLootboxRedemptionsResponse {
    return GetLootboxRedemptionsResponseFromJSONTyped(json, false);
}

export function GetLootboxRedemptionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLootboxRedemptionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'lootboxRedemptions': ((json['lootboxRedemptions'] as Array<any>).map(LootboxRedemptionFromJSON)),
    };
}

export function GetLootboxRedemptionsResponseToJSON(json: any): GetLootboxRedemptionsResponse {
    return GetLootboxRedemptionsResponseToJSONTyped(json, false);
}

export function GetLootboxRedemptionsResponseToJSONTyped(value?: GetLootboxRedemptionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lootboxRedemptions': ((value['lootboxRedemptions'] as Array<any>).map(LootboxRedemptionToJSON)),
    };
}

